import React, { useEffect, useRef, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import './styles.css';
import {
  Bloom,
  ChromaticAberration,
  EffectComposer,
} from '@react-three/postprocessing';
import Model from './Model';
import { MyContext } from './MyContext';
import Interface from './Interface';
import MyCamera from './MyCamera';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { mToCm, mToFeet, mToInches, parseBool } from './utils';
import { calcPanels, toSplitPanels } from './productsAccount';

export default function App() {
  const [width, setwidth] = new useState(4);
  const [length, setlength] = new useState(4);
  const [height, setsetheight] = new useState(2);
  const [numerofwalls, setnumerofwalls] = new useState(2);
  const [numerofcabins, setnumerofcabins] = new useState(0);
  const [numberofcounters, setnumberofcounters] = new useState(0);
  const [bigcabin, setbigcabin] = new useState(true);
  const [splitwall, setsplitwall] = new useState(true);
  const [Lightmode, setLightmode] = new useState(true);
  const [mymodel, setmodel] = new useState(false);
  const [counterdata, setcounterdata] = new useState([
    false,
    false,
    { state: 1 },
  ]);
  const [counter1visible, setcounter1visible] = new useState(false);
  const [counter2visible, setcounter2visible] = new useState(false);
  const [open, setOpen] = React.useState(false);
  const [canvasImg, setCanvasImg] = React.useState('');
  const [cart, setCart] = React.useState([]);
  const [storeData, setStoreData] = useState(null);
  const [unitSystem, setUnitSystem] = useState('m');
  const [currency, setCurrency] = useState('€');
  const [showPrice, setShowPrice] = useState(true);
  const [showWallsLabels, setShowWallsLabels] = useState(true);
  const [currencyMultiplier, setCurrencyMultiplier] = useState(1);
  const [configId, setConfigId] = useState(
    '66082f75-bcb9-450d-a347-09bc43de53f6'
  );
  const [showRequestButton, setShowRequestButton] = useState(true);

  const [otherData, setOtherData] = useState(null);
  const [wallsData, setWallsData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [panels1, setPanels1] = useState(null);
  const [panels2, setPanels2] = useState(null);
  const [feetsCount, setFeetsCount] = useState(0);
  const [bendersCount, setBendersCount] = useState(0);

  const canvasRef = useRef(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    setIsLoading(true);

    const params = new URLSearchParams(window.location.search);

    let unit = params.get('unit_system') || params.get('unitsystem');
    unit = unit?.toLowerCase();

    if (unit === 'in') setsetheight(2.5);

    const param = params.get('customer-configurator-id');

    if (param) setConfigId(params.get(param));

    const endpoint = `https://configurator3d-pixlip-go-api-4d5dd836fde5.herokuapp.com/configurator/${param}/details`;

    fetch(endpoint, {
      headers: {
        'x-api-key': '9DKJF303KJDKFJKJKA22',
      },
    })
      .then(res => res.json())
      .then(data => {
        setStoreData(data);
        setIds(data);
        collectCartData();
        setIsLoading(false);
      });
  }, []);

  function setIds(data) {
    const otherData = {
      counterData: {
        name: 'Go Counter L White',
        productNumber: '1560191',
        id: '',
      },
      doorSetData: {
        name: 'Door set',
        productNumber: '352005',
        id: '',
      },
      feetsData: {
        name: 'Go Foot Plates Set Single Sided',
        productNumber: '352025',
        id: '',
      },
      benderData: {
        name: 'Go System Connector Flex',
        productNumber: '352011',
        id: '',
      },
      connectorT: {
        name: 'Go System Connector T',
        productNumber: '352012',
        id: '',
      },
    };

    const matchUnit = n => {
      const params = new URLSearchParams(window.location.search);
      let param = params.get('unit_system') || params.get('unitsystem');

      param = param.toLowerCase();

      if (param === 'cm') return mToCm(n / 100);

      if (param === 'in') {
        return mToInches(n / 100);
      }

      return n;
    };

    const wallsData = {
      xs: [
        {
          name: `Go Lightbox ${matchUnit(85)} x ${matchUnit(200)}`,
          height: 200,
          productNumber: '1560041',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(85)} x ${matchUnit(225)}`,
          height: 225,
          productNumber: '1560131',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(85)}x ${matchUnit(250)}`,
          height: 250,
          productNumber: '1560081',
          price: 0,
        },
      ],
      sm: [
        {
          name: `Go Lightbox ${matchUnit(100)} x ${matchUnit(200)}`,
          height: 200,
          productNumber: '1560021',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(100)} x ${matchUnit(225)}`,
          height: 225,
          productNumber: '1560141',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(100)} x ${matchUnit(250)}`,
          height: 250,
          productNumber: '1560031',
          price: 0,
        },
      ],
      md: [
        {
          name: `Go Lightbox ${matchUnit(185)} x ${matchUnit(200)}`,
          height: 200,
          productNumber: '1560211',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(185)} x ${matchUnit(225)}`,
          height: 225,
          productNumber: '1560221',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(185)} x ${matchUnit(250)}`,
          height: 250,
          productNumber: '1560231',
          price: 0,
        },
      ],
      lg: [
        {
          name: `Go Lightbox ${matchUnit(200)} x ${matchUnit(200)}`,
          height: 200,
          productNumber: '1560061',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(200)} x ${matchUnit(225)}`,
          height: 225,
          productNumber: '1560151',
          price: 0,
        },
        {
          name: `Go Lightbox ${matchUnit(200)} x ${matchUnit(250)}`,
          height: 250,
          productNumber: '1560091',
          price: 0,
        },
      ],
    };

    data.mapping.forEach(item => {
      const key = Object.keys(otherData).find(
        key => otherData[key].productNumber === item.productNumber
      );

      if (key) {
        otherData[key].id = item.externalProductId;
        otherData[key].price = +item.price;
        return;
      }

      Object.keys(wallsData).forEach(key => {
        let wall = wallsData[key].find(
          wall => wall.productNumber === item.productNumber
        );
        if (wall) {
          wall.id = item.externalProductId;
          wall.price = +item.price;
        }
      });
    });

    setWallsData(wallsData);
    setOtherData(otherData);
    setwidth(5);

    collectCartData();
  }

  function collectCartData() {
    if (!otherData) return;

    let cart = [];
    const panels1 = calcPanels(width);
    if (numerofwalls >= 2) {
      if (numerofwalls === 3) {
        panels1.sm = panels1.sm * 2;
        panels1.lg = panels1.lg * 2;
      }
      //* adjust corner
      if (panels1.sm) {
        panels1.sm -= numerofwalls === 3 ? 2 : 1;
        panels1.xs += numerofwalls === 3 ? 2 : 1;
      } else if (panels1.lg) {
        panels1.lg -= numerofwalls === 3 ? 2 : 1;
        panels1.md += numerofwalls === 3 ? 2 : 1;
      }
    }

    let panels2;
    if (numerofwalls >= 2) {
      panels2 = calcPanels(length);
      if (panels2.sm) {
        panels2.sm--;
        panels2.xs++;
      } else if (panels2.lg) {
        panels2.lg--;
        panels2.md++;
      }

      if (numerofwalls === 3) {
        if (length <= 4) {
          if (panels2.lg) {
            panels2.lg--;
            panels2.md++;
          }

          if (panels2.md) {
            panels2.md--;
            panels2.xs += 2;
          }
        } else {
          if (length === 6) {
            panels2.lg--;
            panels2.md++;
          } else if (length === 5) {
            panels2.lg -= 2;
            panels2.md += 2;
            panels2.xs--;
            panels2.sm++;
          }
        }
      }
    }

    const totalPanels = panels1;
    if (panels2) {
      totalPanels.xs += panels2.xs;
      totalPanels.sm += panels2.sm;
      totalPanels.md += panels2.md;
      totalPanels.lg += panels2.lg;
    }

    if (!splitwall) toSplitPanels(totalPanels);

    for (const key in totalPanels) {
      if (!totalPanels[key]) continue;

      const wall = wallsData[key].find(wall => wall.height / 100 === height);
      cart.push({
        id: wall.id,
        qty: totalPanels[key],
        price: wall.price * totalPanels[key] * currencyMultiplier,
        name: wall.name,
        productNumber: wall.productNumber,
      });
    }

    // feet calculation.
    const feetCount = Math.floor(
      (totalPanels.lg * 3 +
        totalPanels.md * 3 +
        totalPanels.sm * 2 +
        totalPanels.xs * 2) /
        2
    );
    cart.push({
      id: otherData.feetsData.id,
      qty: feetCount,
      price: otherData.feetsData.price * feetCount * currencyMultiplier,
      name: otherData.feetsData.name,
      productNumber: otherData.feetsData.productNumber,
    });

    // benders / connector go flex
    if (numerofwalls > 1)
      cart.push({
        id: otherData.benderData.id,
        qty: numerofwalls - 1,
        price:
          otherData.benderData.price * (numerofwalls - 1) * currencyMultiplier,
        name: otherData.benderData.name,
        productNumber: otherData.benderData.productNumber,
      });

    if (numberofcounters)
      cart.push({
        id: otherData.counterData.id,
        qty: numberofcounters,
        price:
          otherData.counterData.price * numberofcounters * currencyMultiplier,
        name: otherData.counterData.name,
        productNumber: otherData.counterData.productNumber,
      });

    if (numerofcabins) {
      cart.push(
        {
          id: otherData.doorSetData.id,
          qty: numerofcabins,
          price:
            otherData.doorSetData.price * numerofcabins * currencyMultiplier,
          name: otherData.doorSetData.name,
          productNumber: otherData.doorSetData.productNumber,
        },
        {
          id: otherData.connectorT.id,
          qty: numerofcabins,
          price:
            otherData.connectorT.price * numerofcabins * currencyMultiplier,
          name: otherData.connectorT.name,
          productNumber: otherData.connectorT.productNumber,
        }
      );
    }

    setCart(cart);
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('unitsystem') || params.get('unit_system'))
      setUnitSystem(
        params.get('unitsystem').toLowerCase() ||
          params.get('unit_system').toLowerCase()
      );

    if (params.get('currency')) setCurrency(params.get('currency'));

    if (params.get('showprice') || params.get('show_price'))
      setShowPrice(
        parseBool(params.get('showprice')) ||
          parseBool(params.get('show_price'))
      );

    if (params.get('showrequest') || params.get('show_request'))
      setShowRequestButton(
        parseBool(params.get('showrequest')) ||
          parseBool(params.get('show_request'))
      );

    if (params.get('text') || params.get('show_text'))
      setShowWallsLabels(
        parseBool(params.get('text')) || parseBool(params.get('show_text'))
      );

    if (params.get('currencymultiplier') || params.get('currency_multiplier'))
      setCurrencyMultiplier(
        params.get('currencymultiplier') ||
          params.get('currency_multiplier') ||
          1
      );
  }, []);

  const getUnit = n => {
    const system = unitSystem?.toLowerCase() || null;
    if (!unitSystem || system === 'm') return n + ' (M)';

    if (system === 'in') return mToInches(n) + ' (IN)';

    if (system === 'cm') return mToCm(n) + ' (CM)';

    if (system === 'feet' || system === 'ft') return mToFeet(n) + ' (FT)';
  };

  return (
    <>
      <MyContext.Provider
        value={{
          showRequestButton,
          currency,
          showPrice,
          showWallsLabels,
          currencyMultiplier,
          getUnit,
          unitSystem,
          setUnitSystem,
          storeData,
          setStoreData,
          cart,
          setCart,
          canvasImg,
          setCanvasImg,
          handleClose,
          handleOpen,
          open,
          canvasRef,
          counter1visible,
          setcounter1visible,
          counter2visible,
          setcounter2visible,
          Lightmode,
          setLightmode,
          width,
          setwidth,
          length,
          setlength,
          height,
          setsetheight,
          numerofwalls,
          setnumerofwalls,
          numerofcabins,
          setnumerofcabins,
          numberofcounters,
          setnumberofcounters,
          bigcabin,
          setbigcabin,
          splitwall,
          setsplitwall,
          counterdata,
          setcounterdata,
          otherData,
          wallsData,
          isLoading,
          collectCartData,
          panels1,
          panels2,
          feetsCount,
          bendersCount,
          setPanels1,
          setPanels2,
          setFeetsCount,
          setBendersCount,
        }}
      >
        <Interface />

        <div className='input-container'></div>
        <Canvas
          gl={{ preserveDrawingBuffer: true }}
          ref={canvasRef}
          dpr={[1, 1.5]}
          shadows
          camera={{
            position: [-4, isMobile ? 6.5 : 2.5, isMobile ? 13.5 : 6],
            fov: 50,
            near: 0.01,
            far: 100,
          }}
        >
          <color attach='background' args={['#FFF9A2']} />
          <fog
            attach='fog'
            args={['#FFF9A2', isMobile ? 21 : 15.5, isMobile ? 26 : 19]}
          />

          <MyCamera />

          <directionalLight intensity={0.7} />
          <ambientLight />

          <EffectComposer disableNormalPass multisampling={8}>
            <Bloom
              radius={0.7}
              intensity={0.55}
              mipmapBlur
              luminanceThreshold={0.8}
              luminanceSmoothing={0.9}
            />

            <ChromaticAberration
              offset={[0.0003, 0.0003]} // color offset
            />
          </EffectComposer>

          <Model />
        </Canvas>
      </MyContext.Provider>
    </>
  );
}
5;
